import React from 'react'
import Restaurant from "./components/code/Restaurant";
const App = () => {
  return (
    <div>
      <Restaurant />
    </div>
  )
}

export default App